export var BuiltInRoleIds = {
    DmgEndUser: '61ce0965-a3a1-406c-b3da-120b690bfddb',
    DmgDeviceManager: '6cc4b73b-5cdf-421d-8262-e451422f95aa',
    DmgBuildingManager: '0cc3b6e5-d8e0-4962-860f-58820ee03843',
    DmgClientAdministrator: '0237812b-ea1a-458d-9719-f1b0bf14a94e',
    BuildingUser: '5cb23f15-5d3f-4d6d-b39c-0fdb41216d86',
    BuildingManager: '0c2e8cc5-0991-4db4-bba7-8b6edc89bef5',
    Installer: '1523d01c-ab34-4aea-98e9-b83e3ff0b81b',
    Contractor: 'fde57a92-cb21-4500-9487-a2f359e98b21',
    IndependentVideoMonitor: 'b9eca6df-f286-4872-8989-beb88a96ed4a',
    OemVideoMonitor: 'd1e8c242-d39f-4cc1-93d9-fb916dfd6f5f',
    OemManager: 'c401a2fd-6d52-4cc4-a527-7617c31cfae9',
    OemAdministrator: 'd6bed78a-2dfb-4bc0-a60a-6611ceb0bd0b',
    VerticalCityUser: '715fbf4b-fe23-49f7-aff2-d923f13e3694',
    MadUser: 'f5987016-6c76-4118-a7d7-52ced6f208f7',
    MadTechSupport: 'c6d2383c-d1ee-4a21-9d77-e697f72b55c5',
    BillingUser: '771fd96d-b13c-4549-b94d-95763d3d577c',
    SiteAdministrator: '1910d702-f9f7-46bd-903a-0c7b9f80257b',
};
export var Permission = {
    ViewUsers: "uv",
    CreateUser: "uc",
    EditUser: "ue",
    DeleteUser: "ud",
    AssignUser: "ua",
    CreateBuilding: "bc",
    EditBuilding: "be",
    DeleteBuilding: "bd",
    EditBuildingFeatures: "bf",
    Broadcast: "bb",
    ManageBuildingLinks: "bl",
    ViewDevices: "dv",
    CreateDevice: "dc",
    EditDevice: "de",
    DeleteDevice: "dd",
    CommandDevice: "dx",
    AdminDevice: "da",
    ViewThemes: "tv",
    CreateTheme: "tc",
    EditTheme: "te",
    DeleteTheme: "td",
    UploadTheme: "tu",
    ManageEcsLayer: "t1",
    AdminTheme: "ta",
    CreateOrganization: "oc",
    LinkOrganization: "ol",
    ManageOrgExternalIds: "oi",
    ViewCalls: "cv",
    AnswerCall: "ca",
    ViewOldCalls: "ch",
    AllBuildings: "*b",
    AllOrganizations: "*o",
    AssumeUser: "*u",
    ManageDeviceTypes: "st",
    ManageUploads: "su",
    ManageBilling: "$$",
    DebugRead: "xr",
    DebugWrite: "xw",
    DmgRoles: "dmg",
    StandardRoles: "std",
    Admin: "**",
};
